module.exports = __webpack_public_path__ + "static/img/risolto_logo_full.522025fc.png";